import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', name: 'EN' },
  { code: 'zh', name: 'ZH' },
  { code: 'ko', name: 'KO' },
  { code: 'ja', name: 'JA' },
  { code: 'id', name: 'ID' },
  { code: 'th', name: 'TH' }
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    console.log('=== LANGUAGE CHANGE INITIATED ===');
    console.log('Target language:', lng);
    console.log('Current language:', i18n.language);

    // Immediately set localStorage
    localStorage.setItem('i18nextLng', lng);
    console.log('localStorage set to:', lng);

    // Clear any browser language detection
    localStorage.removeItem('i18nextLng-en');
    localStorage.removeItem('i18nextLng-zh');
    localStorage.removeItem('i18nextLng-ko');
    localStorage.removeItem('i18nextLng-ja');
    localStorage.removeItem('i18nextLng-id');
    localStorage.removeItem('i18nextLng-th');

    // Force reload immediately - don't wait for async operations
    window.location.href = window.location.pathname + '?lang=' + lng;
  };

  // Get current language, normalize it
  const currentLang = i18n.language?.split('-')[0] || 'en';

  return (
    <select
      value={currentLang}
      onChange={(e) => changeLanguage(e.target.value)}
      className="bg-bg-secondary text-text-light border border-white/10 rounded-lg px-1.5 py-1 text-sm focus:outline-none focus:border-gradient-from w-[70px] md:w-[90px]"
      aria-label="Select language"
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code} className="py-1">
          {lang.code.toUpperCase()}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;